import { ApiError } from '@lp/portal-ui';
import type { ErrorCode } from '@lp/shared';

const MESSAGES: Record<ErrorCode, string> = {
  VALIDATION_FAILED: '資料有誤，請檢查標示的欄位。',
  UNAUTHENTICATED: '登入已逾時，請重新登入。',
  FORBIDDEN: '你的帳戶沒有權限進行此操作。',
  NOT_FOUND: '找不到相關資料，可能已被刪除。',
  CONFLICT: '資料有衝突，請重新載入後再試。',
  RATE_LIMITED: '嘗試次數過多，請稍後再試。',
  EMAIL_TAKEN: '此電郵已被使用。',
  INVALID_CREDENTIALS: '電郵或密碼不正確。',
  OTP_REQUIRED: '請輸入雙重認證驗證碼。',
  CODE_INVALID: '驗證碼不正確。',
  CODE_EXPIRED: '驗證碼已過期。',
  BRAND_NOT_FOUND: '找不到品牌資料。',
  BRAND_SUSPENDED: '品牌帳戶已暫停，請聯絡 LoyaltyPlus。',
  POS_UNAVAILABLE: '暫時未能連接 POS 系統，請稍後再試。',
  POS_REJECTED: 'POS 系統未能完成此操作。',
  INSUFFICIENT_POINTS: '積分不足。',
  NOT_IMPLEMENTED: '此功能尚未開放。',
  LIMIT_REACHED: '已達你的計劃上限。如需升級，請聯絡 LoyaltyPlus。',
  MODULE_OFF: '你的計劃未包括此功能。如需開通，請聯絡 LoyaltyPlus。',
  SMS_UNAVAILABLE: '手機短訊服務暫時未能使用，請改用電郵。',
  AI_UNAVAILABLE: 'AI 服務暫時未能使用，請稍後再試。',
  AI_REJECTED: 'AI 服務未能處理這段描述（可能涉及不適當內容），請修改後再試。',
  EMAIL_FAILED: '電郵發送服務暫時未能發出測試電郵，請稍後再試。',
  INTERNAL: '系統發生錯誤，請稍後再試。',
};

let readOnlyMode = false;
/** The signed-in layout sets this for platform admins with read-only rights, so refused changes say why. */
export function setReadOnlyMode(on: boolean) {
  readOnlyMode = on;
}

export function errorCode(e: unknown): ErrorCode | null {
  return e instanceof ApiError ? e.code : null;
}

/** A message for staff in Traditional Chinese; `overrides` replaces the text for specific codes. */
export function errorMessage(e: unknown, overrides: Partial<Record<ErrorCode, string>> = {}): string {
  if (e instanceof ApiError && e.code === 'FORBIDDEN' && readOnlyMode && !overrides.FORBIDDEN) return '唯讀模式：你只可查看此品牌的資料，不能作出更改。';
  if (e instanceof ApiError) return overrides[e.code] ?? MESSAGES[e.code] ?? e.message;
  if (e instanceof TypeError) return '網絡連線有問題，請檢查連線後再試。';
  return MESSAGES.INTERNAL;
}

/** Field errors sent by the server (`error.fields`), keyed by field path such as `title.en`. */
export function errorFields(e: unknown): Record<string, string> {
  return e instanceof ApiError ? e.fields : {};
}
